<div class="container py-3">
  <div class="card">
    <div class="card-body p-5">
      <div class="row gy-4 my-0">
        <h5 class="h1 col-12 m-0">Release details</h5>
        @if (release().releaseData; as data) {
          <div class="col-12">
            <div class="row gy-4">
              @if (release().id && !!release().releaseStatus?.status) {
                <app-form-field label="Id" class="col-6 col-md-4" [value]="release().id"
                                [editMode]="false" [includeMargin]="false" [renderOptional]="false">
                  <input required class="form-control" [ngModel]="release().id" disabled>
                </app-form-field>
              }
              <app-form-field label="Consignment number" class="col-6 col-md-4" [(value)]="data.consignmentNumber"
                              [editMode]="editMode()" [includeMargin]="false" [renderOptional]="false">
                <app-search required [ngModel]="data.consignmentNumber" [minCharacters]="3"
                            [searchFunction]="refData.findAllConsignments"
                            resultFormatter="masterConsignment.consignmentNumber"
                            (ngModelChange)="selectConsignment($event)"
                            newValueFromInputFunction="masterConsignment.consignmentNumber"
                            [disabled]="!!release().releaseStatus?.status">
                </app-search>
              </app-form-field>
            </div>
          </div>
          @if (data.consignmentNumber) {
            <div class="col-12">
              <div class="row gy-4">
                @if (selectedConsignment?.crn) {
                  @if (data.consignmentNumber) {
                    <app-form-field label="Container number" class="col-6 col-md-4" [(value)]="data.equipmentNumber"
                                    [editMode]="editMode()" [includeMargin]="false" [renderOptional]="false">
                      <app-search [(ngModel)]="data.equipmentNumber" required
                                  [optionsProvider]="containerNumbersOfConsignment"
                                  [disabled]="!!release().releaseStatus?.status"
                                  placeholder="Search for container number"></app-search>
                    </app-form-field>
                  }
                  <app-form-field label="Terminal" class="col-6 col-md-4" [value]="data.terminalShortName"
                                   [editMode]="false" [includeMargin]="false"
                                   [formatter]="terminalOrganisationName" [renderOptional]="false">
                    <app-search [ngModel]="data.terminalShortName" [options]="terminals"
                                [inputFormatter]="terminalOrganisationName" [disabled]="true"></app-search>
                  </app-form-field>
                  <app-form-field label="CRN" class="col-6 col-md-4" [value]="release().crn"
                                  [editMode]="false" [includeMargin]="false" [renderOptional]="false">
                    <input class="form-control" [ngModel]="release().crn" disabled>
                  </app-form-field>
                } @else {
                  <app-form-field label="Container number" class="col-6 col-md-4" [(value)]="data.equipmentNumber"
                                  [editMode]="editMode()" [includeMargin]="false" [renderOptional]="false">
                    <input class="form-control" [(ngModel)]="data.equipmentNumber"
                           required [disabled]="!!release().releaseStatus?.status"
                           (change)="data.equipmentNumber=$event.target?.value?.toUpperCase()">
                  </app-form-field>
                  <app-form-field label="Terminal" class="col-6 col-md-4" [(value)]="data.terminalShortName"
                                  [editMode]="editMode()" [includeMargin]="false"
                                  [formatter]="terminalOrganisationName" [renderOptional]="false">
                    <app-search [(ngModel)]="data.terminalShortName" required [options]="terminals"
                                [inputFormatter]="terminalOrganisationName"
                                [disabled]="!!release().releaseStatus?.status"
                                placeholder="Search for terminal"></app-search>
                  </app-form-field>
                  <app-form-field label="CRN" class="col-6 col-md-4" [(value)]="release().crn"
                                  [editMode]="editMode()" [includeMargin]="false" [renderOptional]="false">
                    <input class="form-control" [(ngModel)]="release().crn" [disabled]="!!release().releaseStatus?.status"
                           [required]="data.terminalShortName === 'APMII'"
                           (change)="release().crn=$event.target?.value?.toUpperCase()">
                  </app-form-field>
                }
              </div>
            </div>
          }
          <div class="col-12">
            <div class="row gy-4">
              <app-form-field label="Release deadline" class="col-6 col-md-4" [(value)]="data.releaseDeadline"
                              [editMode]="editMode()" [includeMargin]="false">
                <app-date-field [defaultTime]="'12:00'" [(ngModel)]="data.releaseDeadline"></app-date-field>
              </app-form-field>
            </div>
          </div>
          <div class="col-12">
            <div class="row gy-4">
              <app-form-field label="Release modality" class="col-6 col-md-4" [(value)]="data.releaseModality"
                              [editMode]="editMode()" [includeMargin]="false">
                <app-search [(ngModel)]="data.releaseModality" [options]="['barge', 'road', 'rail']"
                            placeholder="No preference"></app-search>
              </app-form-field>
            </div>
          </div>
          <div class="col-12">
            <div class="row gy-4">
              <app-form-field label="Remarks" class="col-12" [(value)]="data.remarks"
                              [editMode]="editMode()" [includeMargin]="false">
                <textarea class="form-control" [(ngModel)]="data.remarks"></textarea>
              </app-form-field>
            </div>
          </div>
          <div class="col-12">
            <div class="row gy-4">
              <app-form-field label="Empty" class="col-6 col-md-4" [value]="release().releaseData.empty"
                              [editMode]="editMode()" [includeMargin]="false" [renderOptional]="false">
                <app-yes-no [(ngModel)]="release().releaseData.empty" required></app-yes-no>
              </app-form-field>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
